import React, { useEffect, useRef, useState } from 'react';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Dialog from '../components/ActionDialog';
import { useTranslation } from 'react-i18next';
import SecretTextField from '../components/SecretTextField';

export { adminPasswordConfig, adminPasswordErrorKey } from '../services/AdminConfirmation';

// No storage, API defaults, or elevated-session cache: each save asks again.
export default function useAdminPasswordConfirmation() {
    const { t } = useTranslation();
    const pending = useRef(null);
    const [open, setOpen] = useState(false);
    const [password, setPassword] = useState('');
    useEffect(() => () => { pending.current?.(null); pending.current = null; }, []);
    const finish = value => {
        const resolve = pending.current;
        pending.current = null;
        setPassword(''); setOpen(false);
        resolve?.(value);
    };
    const requestPassword = () => {
        if (pending.current) return Promise.resolve(null);
        setPassword(''); setOpen(true);
        return new Promise(resolve => { pending.current = resolve; });
    };
    const passwordDialog = <Dialog open={open} onClose={() => finish(null)} fullWidth maxWidth="xs"
        aria-labelledby="admin-password-title" PaperProps={{ component: 'form', onSubmit: event => {
            event.preventDefault(); if (password) finish(password);
        } }}>
        <DialogTitle id="admin-password-title">{t('adminConfirmation.title')}</DialogTitle>
        <DialogContent sx={{ pt: '12px !important' }}>
            <SecretTextField autoFocus required fullWidth type="password" autoComplete="current-password"
                label={t('adminConfirmation.password')} value={password} onChange={event => setPassword(event.target.value)} />
        </DialogContent>
        <DialogActions>
            <Button onClick={() => finish(null)}>{t('common.cancel')}</Button>
            <Button type="submit" variant="contained" disabled={!password}>{t('adminConfirmation.confirm')}</Button>
        </DialogActions>
    </Dialog>;
    return { requestPassword, passwordDialog };
}
